import * as types from "./mutation-types";

export const setData = ({ commit }, payload) => {
  commit(types.SET_DATA, payload);
};
